import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const pageBlockClasses = {
  wrapper: '!p-16 sm:!p-24',
};

export const titleWrapperStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
};

export const getSummaryWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: `repeat(${length}, 1fr)`,
  },
});

export const summaryCardStyles = {
  padding: '4px 8px',

  '& .text-value:not(.truncate)': {
    whiteSpace: 'pre-line',
  },
};

export const commonTooltipStyles = {
  padding: '24px',
  maxWidth: 'none',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: '5px 0px 12px 0px #00000026, 0px 5px 12px 0px #00000026',
};
